import EditUserForm from './component'

export default EditUserForm
